import { render, staticRenderFns } from "./RelationshipPreviousYN.vue?vue&type=template&id=112801ce"
import script from "./RelationshipPreviousYN.vue?vue&type=script&lang=js"
export * from "./RelationshipPreviousYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports